import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/mobile/service_info`;
export default {
    /***
     * GET /v1.0/mobile/service_info/{id}
        // 获取服务详情
     * ServiceDto {
        content (string, optional): 内容 ,
        id (string, optional): 系统编号 ,
        is_collect (integer, optional): 是否收藏(1是0否) ,
        name (string, optional): 服务名称 ,
        status (integer, optional): 状态(2已上架3已下架)
        }
     */
    getServiceDetail(id) {
        return axios({
            url: `${_MODULE}/${id}`,
            loading: false
        })
    },
    /****
     * 获取评价详情列表数据
     * {"pageNum":1,"pageSize":20,"status":1,"search":"清"}
     * SearchInformationReq {
        pageNum (integer, optional): 分页数 ,
        pageSize (integer, optional): 分页大小 ,
        search (string, optional): 查询条件
        }

        RspPageDto«ServiceInfoPageDto» {
        count (integer, optional): 记录总数 ,
        data (Array[ServiceInfoPageDto], optional): 数据
        }
        ServiceInfoPageDto {
        coverImg (string, optional): 图片 ,
        id (string, optional): 服务id ,
        isMultiple (integer, optional),
        name (string, optional): 名称 ,
        price (number, optional): 价格
        }
     */
    // search
    search(data) {
        return axios({
            url: `${_MODULE}/search`,
            method: "POST",
            loading: false,
            data
        })
    }
}


// WEBPACK FOOTER //
// ./src/apis/src/serviceInfo.js